import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  AddUserAttachmentUseCaseInput,
  AddUserAttachmentUseCaseOutput,
  IAppErrorFactory,
  IUsersService,
  IAddUserAttachmentUseCase,
  IUseCaseOutputFactory,
  IUserAttachment,
  IUserAttachmentFactory,
} from '../../types'

@injectable()
export default class AddUserAttachmentInteractor implements IAddUserAttachmentUseCase {
  @inject(symbols.IUsersService) private usersService: IUsersService

  @inject(symbols.IUserAttachmentFactory) private userAttachmentFactory: IUserAttachmentFactory

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    userAttachment: null | IUserAttachment
  }>

  async handle(input: AddUserAttachmentUseCaseInput): Promise<AddUserAttachmentUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        userAttachment: null,
      },
    })
    try {
      const base = await this.usersService.addUserAttachment(input)
      output.data.userAttachment = this.userAttachmentFactory.create({ base })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }
}
